import {GET, POST} from "@/services/gateway";
import {trimString} from "@/components/common/utils/trimString";

const listUsers = ({pagination, search, filter}) => {
  return POST('google/user/list', {pagination, search, filter});
}

const getUserDetails = (id) => {
  return GET('google/contact/user', {id})
}

const listSnapshots = ({userId, date, dateTo}) => {
  return POST('google/contact/snapshot/list', {userId, date, dateTo})
}

const createBackup = (userId) => {
  return GET('google/contact/backup', {userId})
}

const exportSnapshot = ({
                          snapshotDateTime,
                          sourceIds,
                          searchTerm,
                          selectedIds,
                          outputFormat,
                          code,
                          extension,
                          storageDestinationId,
                          dataType,
                          storageDestinationType
                        }) => {
  return POST('google/contact/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    selectedIds,
    outputFormat,
    extension,
    storageDestinationId,
    dataType,
    storageDestinationType
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           snapshotId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('google/contact/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm: trimString(searchTerm),
    destinationId,
    snapshotId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null});
}

export {
  listUsers,
  getUserDetails,
  listSnapshots,
  createBackup,
  exportSnapshot,
  restoreSnapshot
}
